<div style="margin-top: 15px; min-height: 40px; display: flex; align-items: baseline; gap: 15px">
  <span>Active filters:</span>
  <mat-chip-list style="margin-right: 5px">
    <mat-chip *ngFor="let filter of selectedFilters" (removed)="remove(filter)">
      <span style="max-width: 96%">{{ filter.prefix ? filter.prefix + ':' : '' }} {{ filter.label }}</span>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
</div>
